<template>
    <div class="nav-steps">
        <a
            class="nav-steps__link"
            :class="{
                'nav-steps__link--current' : step === 1,
                'nav-steps__link--done': allowedStep >= 1 && step !== 1
            }"
            @click="emitFirstStep"
        >
            <span class="nav-steps__step">{{ ($t('NavigationSteps.step1')) }}</span>
        </a>
        <i
            class="nav-steps__arrow nav-steps__arrow--right"
            :class="{
                'nav-steps__arrow--active': allowedStep > 1
            }"
        ></i>
        <a
            class="nav-steps__link"
            :class="{
                'nav-steps__link--current' : step === 2,
                'nav-steps__link--done': allowedStep >= 2 && step !== 2
            }"
            @click="emitSecondStep"
        >
            <span class="nav-steps__step">{{ ($t('NavigationSteps.step2')) }}</span>
        </a>
        <i
            class="nav-steps__arrow nav-steps__arrow--right"
            :class="{
                'nav-steps__arrow--active': allowedStep > 2
            }"
        ></i>
        <a
            class="nav-steps__link"
            :class="{
                'nav-steps__link--current' : step === 3,
                'nav-steps__link--done': allowedStep >= 3 && step !== 3
            }"
            @click="emitThirdStep"
            >
            <span class="nav-steps__step">{{ ($t('NavigationSteps.step3')) }}</span>
        </a>
    </div>
</template>

<script>
export default {
  // props
  props: {
    step: Number,
    allowedStep: Number
  },

  setup (step, context) {
    // methods
    const emitFirstStep = () => {
      context.emit('emitFirstStep')
    }
    const emitSecondStep = () => {
      context.emit('emitSecondStep')
    }
    const emitThirdStep = () => {
      context.emit('emitThirdStep')
    }

    return {
      emitFirstStep, emitSecondStep, emitThirdStep
    }
  }
}

</script>

<style lang="scss" scoped>
    .nav-steps {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &__link {
            text-decoration: none;
            position: relative;
            display: block;

            &--current {
                cursor: pointer;

                > span {
                    color: $color-active;
                    font-weight: var(--fontweight-bold);
                    position: relative;

                    &:after {
                        content: '';
                        position: absolute;
                        width: 100%;
                        height: 1px;
                        background-color: $color-active;
                        bottom: -5px;
                        left: 0;
                    }
                }
            }

            &--done {
                cursor: pointer;
                position: relative;

               > span {
                color: $color-active;
                font-weight: var(--fontweight-regular);

                    &:after {
                        content: '';
                        position: absolute;
                        width: 0;
                        height: 1px;
                        background-color: $color-active;
                        bottom: -6px;
                        left: 0;
                        transition: width 0.5s;
                    }

                    &:hover {
                        &:after {
                            width: 100%;
                        }
                    }
                }
            }
        }
        &__step {
            color: var(--color-inactive);
            display: block;

            // Include the base font properties
            @include font-properties-base(var(--fontsize-s), var(--fontweight-regular), normal, 1.5);

            // Include the tablet font properties
            @include font-properties-tablet(var(--fontsize-m), var(--fontweight-regular), normal, 1.5);
        }
        &__arrow {
            display: flex;
            top: 8px;
            width: 10px;
            height: 10px;
            border-top: 1px solid var(--color-inactive);
            border-left: 1px solid var(--color-inactive);

            &--right {
                transform: rotate(135deg);
                -webkit-transform: rotate(135deg);
            }

            &--active {
                border-color: var(--black950);
            }
        }
    }
</style>
